"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const NHRectangle = createSVGIcon(
  <>
    <rect
      x="0.5"
      y="0.5"
      width="49.1102"
      height="73"
      rx="24.5551"
      stroke="currentColor"
    />
    <path
      d="M20.7053 26.8031H22.0198V18.7901L28.2988 26.8031H29.4035V16.6226H28.075V24.4398L21.9499 16.6226H20.7053V26.8031Z"
      fill="currentColor"
    />
    <path
      d="M20.9309 56.5198H22.2734V52.0168H27.8391V56.5198H29.1956V46.3392H27.8391V50.7722H22.2734V46.3392H20.9309V56.5198Z"
      fill="currentColor"
    />
    <line
      x1="18.6456"
      y1="36.2087"
      x2="31.4645"
      y2="36.2087"
      stroke="currentColor"
    />
  </>,
  "NHRectangle",
  { viewBox: "0 0 51 74", titleAccess: "NHRectangle", fill: "none" }
);
